import React, { useEffect, useState } from 'react';
import { CommonCard } from '@/components/common/CommonCard';
import { IAnalyticsFilters, IAnalyticsSummaryResponse } from '@/interfaces/Dashboard/dashboard.interface';
import { formatRand } from '@/utility/helper';
import { DollarSign, TrendingUp, ShoppingBag, Users, Store, Truck, Package, Clock } from 'lucide-react';
import { CommonCardSkeleton } from '@/components/ui/Loaders/DashboardSkeletons';

interface AnalyticsSummaryStripProps {
    filters: IAnalyticsFilters;
    data: IAnalyticsSummaryResponse['data'] | null;
    isLoading: boolean;
}

export const AnalyticsSummaryStrip: React.FC<AnalyticsSummaryStripProps> = ({ filters, data, isLoading }) => {
    
    if (isLoading) {
        return (
            <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-4 mb-6 animate-pulse">
                {Array.from({ length: 8 }).map((_, i) => (
                    <CommonCardSkeleton key={i} />
                ))}
            </div>
        );
    }

    const summaryCards = [
        { label: 'Total Revenue', value: formatRand(data?.totalRevenue), icon: <DollarSign />, color: '#10B981' },
        { label: 'GMV', value: formatRand(data?.gmv), icon: <TrendingUp />, color: '#3B82F6' },
        { label: 'Total Orders', value: data?.totalOrders ?? 0, icon: <ShoppingBag />, color: '#F59E0B' },
        { label: 'Total Customers', value: data?.totalCustomers ?? 0, icon: <Users />, color: '#8B5CF6' },
        { label: 'Active Stores', value: data?.activeStores ?? 0, icon: <Store />, color: '#EC4899' },
        { label: 'Active Drivers', value: data?.activeDrivers ?? 0, icon: <Truck />, color: '#14B8A6' },
        { label: 'Products Sold', value: data?.productsSold ?? 0, icon: <Package />, color: '#F97316' },
        { label: 'Avg Delivery Time', value: `${data?.avgDeliveryTime ?? 0}m`, icon: <Clock />, color: '#6366F1' },
    ];

    return (
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-4 gap-4 mb-6">
            {summaryCards.map((card, index) => (
                <CommonCard
                    key={index}
                    label={card.label}
                    value={card.value}
                    icon={card.icon}
                    iconColor={card.color}
                />
            ))}
        </div>
    );
};
